<template>
  <form @submit.prevent="submit" class="flex flex-col">
    <label class="mb-2">Número de grupos que se asignará a cada curso</label>
    <input
      type="number"
      min="1"
      max="26"
      v-model="num"
      class="w-full px-4 py-3 text-gray-700 rounded border-2 focus:border-blue-500 leading-thight mb-3"
    />
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        class="px-4 py-2 border border-gray-600 hover:bg-indigo-600 hover:text-white rounded"
      >
        Crear
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  props: {
    location: {
      type: String,
    },
  },
  data() {
    return {
      num: 1,
    };
  },
  computed: {
    ...mapState(["tabs", "user"]),
  },
  methods: {
    ...mapMutations(["hideModal"]),
    ...mapActions(["selectTab"]),
    submit() {
      const defaultCourses = {
        Infantil: 3,
        Primaria: 6,
        ESO: 4,
        Bachillerato: 2,
        Graduado: 1,
      };

      const allGroups = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ"];

      const data = [];
      let counter = 1;

      Object.entries(defaultCourses).forEach(([key, value]) => {
        for (let index = 1; index <= value; index++) {
          const groups = allGroups.slice(0, this.num);
          const descripcion = counter === 16 ? key : `${index}º ${key}`;

          data.push({
            ID_Location: this.location,
            ID_Curso: `${this.cleanString(descripcion, 4)}${this.location}`,
            colegio: this.user.colegio,
            grupos: groups.join(","),
            descripcion,
            orden: counter++,
          });
        }
      });

      axios
        .post("server/index.php", {
          action: "createAllCourses",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
          timestamp: Date.now(),
        })
        .then(() => {
          const coursesTab = this.tabs.find((tab) => tab.title === "Cursos");
          this.hideModal();
          this.selectTab(coursesTab);
        });
    },
    cleanString(cadena, length, tolower = false, space = "") {
      if (!cadena) return cadena;

      // Definimos los caracteres que queremos eliminar
      var specialChars = "!@#$^&%*()+=-[]/{}|:<>?,.ºª↵";

      // Los eliminamos todos
      for (var i = 0; i < specialChars.length; i++) {
        cadena = cadena.replace(new RegExp("\\" + specialChars[i], "gi"), "");
      }

      // Lo queremos devolver limpio en minusculas
      cadena = tolower ? cadena.toLowerCase() : cadena.toUpperCase();

      // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
      cadena = cadena.replace(/ /g, space);

      // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
      cadena = cadena.replace(/↵/gi, "");
      cadena = cadena.replace(/á/gi, "a");
      cadena = cadena.replace(/é/gi, "e");
      cadena = cadena.replace(/í/gi, "i");
      cadena = cadena.replace(/ó/gi, "o");
      cadena = cadena.replace(/ú/gi, "u");
      cadena = cadena.replace(/ñ/gi, "n");

      return length ? cadena.substring(0, length) : cadena;
    },
  },
};
</script>
